interface HeaderNavbarDataItem {
  id: string;
  title: string;
  to?: string;
  href?: string;
}

export enum HeaderNavbar {
  planYourWedding = 'planYourWedding',
  registry = 'registry',
  resources = 'resources',
  mobileNavMenu = 'mobileNavMenu',
}

type HeaderNavbarDataType = {
  [key in HeaderNavbar]: {
    wedding: HeaderNavbarDataItem[];
    baby: HeaderNavbarDataItem[];
  };
};

export const headerNavbarDataV2: HeaderNavbarDataType = {
  [HeaderNavbar.planYourWedding]: {
    wedding: [
      {
        id: 'features-wedding-website',
        to: '/wedding-website',
        title: 'Wedding Website',
      },
      {
        id: 'features-guest-list',
        to: '/guest-list',
        title: 'Guest List',
      },
      {
        id: 'features-save-the-date',
        to: '/save-the-date',
        title: 'Save the Dates',
      },
      {
        id: 'features-wedding-invitations',
        to: '/wedding-invitations',
        title: 'Invitations',
      },
      {
        id: 'features-smart-rsvp',
        to: '/online-rsvp',
        title: 'Smart RSVP',
      },
      {
        id: 'features-app',
        to: '/app',
        title: 'Mobile App',
      },
    ],
    baby: [],
  },
  [HeaderNavbar.registry]: {
    wedding: [
      {
        id: 'features-registry',
        to: '/registry',
        title: 'Wedding Registry',
      },
      {
        id: 'features-shop',
        to: '/shop',
        title: 'Shop Wedding',
      },
      {
        id: 'features-cash-fund-registry',
        to: '/cash-fund-registry',
        title: 'Zero-Fee Cash Funds',
      },
      {
        id: 'features-honeymoon-registry',
        to: '/honeymoon-registry',
        title: 'Honeymoon Funds',
      },
    ],
    baby: [
      {
        id: 'features-baby-registry',
        to: '/baby-registry',
        title: 'Baby Registry',
      },
      {
        id: 'features-baby-shop',
        to: '/shop/baby',
        title: 'Shop Baby',
      },
      {
        id: 'features-baby-zero-fee-cash-fund',
        to: '/shop/baby/catalog/baby-cash-funds',
        title: 'Zero-Fee Cash Funds',
      },
      // TODO - Once we have Babymoon Funds will enable it back
      // {
      //   id: 'features-baby-babymoon-cash-funds',
      //   to: '/babymoon-registry',
      //   title: 'Babymoon Funds',
      // },
    ],
  },
  [HeaderNavbar.resources]: {
    wedding: [
      {
        id: 'menu2blog',
        href: 'https://withjoy.com/blog/',
        title: 'Wedding Ideas',
      },
      {
        id: 'menu2babyblog',
        href: 'https://withjoy.com/baby-guides/',
        title: 'Baby & Parenting Guides',
      },
      {
        id: 'menu2designs',
        href: '/designs',
        title: 'Design Templates',
      },
      {
        id: 'menu2faq',
        to: '/faq',
        title: 'FAQs',
      },
      {
        id: 'menu2help',
        href: 'https://help.withjoy.com/',
        title: 'Help & Support',
      },
      {
        id: 'menu2pricing',
        to: '/pricing',
        title: 'Pricing',
      },
    ],
    baby: [],
  },
  [HeaderNavbar.mobileNavMenu]: {
    wedding: [],
    baby: [],
  },
};
